<template>
  <div class="table" ref="mainContentRef">
    <div class="row main-header">
      <div class="column table__header">
        <div class="row item main-first-title">기사</div>
        <div class="row item main-second-title">
          <div>차량</div>
          <div class="vehicle-driving-item">예상운행 / 실제운행 (km)</div>
        </div>
      </div>
      <template v-for="(header, index) in headers">
        <div :key="index" class="column">
          <div class="row item sub-first-title">
            <div>{{ header[0].driverName }}</div>
          </div>
          <div class="row group">
            <template v-for="subheader in header">
              <div :key="subheader" class="row item group__item sub-second-title">
                <slot name="vehicleInfo" :item="subheader"></slot>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="row main-content">
      <div class="column table__sub-header">
        <template v-for="(time, index) in times">
          <div :key="index" class="row item time-item" :style="styleTime(time)">
            {{ time }}
          </div>
        </template>
      </div>
      <template v-for="(content, i) in contents">
        <div class="column row item data-cell-item" :key="i">
          <v-divider
              v-if="nowDate"
              class="table--divider"
              :style="dividerPosition"
          ></v-divider>
          <template v-for="(schedule, index) in content">
            <c-vertical-calendar-schedule
                :key="index"
                :schedule="schedule"
                :selectedDate="selectedDate"
                :unit-height="unitHeight"
                :disableTooltip="checkDisableTooltip(schedule)"
                :disableMenu="checkDisableMenu(schedule)"
            >
              <template #tooltipInfo="schedule">
                <c-scheduler-tooltip :schedule="schedule" />
              </template>
              <template #menuInfo="schedule">
                <slot name="menuInfo" :schedule="schedule"></slot>
              </template>
            </c-vertical-calendar-schedule>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import CVerticalCalendarSchedule from "./CVerticalCalendarSchedule.vue";
import CSchedulerTooltip from "../components/CSchedulerTooltip.vue";

export default {
  components: { CVerticalCalendarSchedule, CSchedulerTooltip },
  props: {
    selectedDate: {
      type: String,
    },
    headers: {
      type: Array,
    },
    contents: {
      type: Array,
    },
    startTime: {
      type: Number,
    },
    endTime: {
      type: Number,
    },
    onTooltip: {
      type: Function,
    },
    onMenu: {
      type: Function,
    },
    isActive: {
      type: Boolean
    }
  },
  data() {
    return {
      times: Array.from(
          { length: 24 },
          (v, i) => (i < 10 ? "0" + i : i) + ":00"
      ),
      rowSize: 30, // time당 한 column 사이즈
      sizeUnit: "px",
    };
  },
  computed: {
    baseTimes() {
      return Array.from({ length: this.endTime - this.startTime }, (v, i) =>
          this.$moment(this.startTime + i, "H")
      );
    },
    contentHeight() {
      return this.times.length * this.rowSize;
    },
    unitHeight() {
      return this.rowSize / 60; // TODO: 분당 em 사이즈 변화하도록 수정 (min: 1, max: 유동적)
    },
    dividerPosition() {
      const startPosition = this.$moment
          .duration(this.$moment().diff(this.$moment(0, "H")))
          .asMinutes();
      return {
        top: startPosition * this.unitHeight + "px",
        borderColor: "red",
      };
    },
    nowDate() {
      return this.selectedDate === this.$func.curDateString();
    }
  },
  methods: {
    onUpdate() {
      const resizingRowHeight =
          this.$refs.mainContentRef.offsetHeight / this.baseTimes.length;
      this.rowSize = resizingRowHeight <= 20 ? 20 : resizingRowHeight;
      this.$refs.mainContentRef.scrollTop = this.rowSize * this.startTime;
    },
    checkDisableTooltip(schedule) {
      return !['reservation', 'delivery', 'breakTime'].includes(schedule.category);
    },
    checkDisableMenu(schedule) {
      return !['reservation', 'delivery', 'breakTime'].includes(schedule.category);
    },
    styleTime(time) {
      if (!this.nowDate) {
        return {
          height: this.rowSize + 'px'
        };
      }
      const hour = time.split(':')[0]

      if (Number(hour) === this.$moment().hours()) {
        return {
          color: 'red',
          height: this.rowSize + 'px'
        };
      } else {
        return {
          height: this.rowSize + 'px'
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onUpdate();
    })
  },

  updated() {
    if (this.isActive) {
      this.onUpdate();
    }
  },
};
</script>
<style lang="scss" scoped>
$table-border-color: lightgrey;
$border-style: 1px solid $table-border-color;

.table {
  width: 100%;
  height: 600px;
  overflow: auto;
  border-top: $border-style;
  border-left: $border-style;
}

.table__header, .table__sub-header {
  position: sticky;
  left: 0;
  background: #f7f7f7;
  z-index: 2;
}

.row {
  display: flex;
  margin: 0;
  flex: none;
  flex-wrap: nowrap;

  &.item {
    border-bottom: $border-style;
    border-right: $border-style;
  }
}

.main-header, .main-content {
  width: max-content;
}

.main-header {
  position: sticky;
  top: 0;
  background: #f7f7f7;
  z-index: 3;
}

.main-content {
  background: #f7f7f7;
}

.main-first-title {
  width: 120px;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.main-second-title {
  width: 120px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 10px;
  border-bottom: $border-style !important;
}

.vehicle-driving-item {
  font-size: 10px;
}

.sub-first-title {
  height: 30px;
  justify-content: center;
  align-items: center;
}

.sub-second-title {
  width: 150px;
  height: 40px;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
}

.time-item {
  width: 120px;
  justify-content: center;
  align-items: center;
}

.item {
  font-size: 12px;
}

.table--divider {
  position: absolute;
  width: 100%;
  border-width: 1px;
  z-index: 1;
}

.data-cell-item {
  position: relative;
  width: 150px;
  display: flex;
  justify-content: center;
}

.group {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  &__item {
    justify-content: center;

  }
}
</style>